// Redux slice for managing output material list loading, data, and errors
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { getOutputMaterialList } from './match-maker.thunk';
import type { OutputMaterialListResponse } from '../utils/match-maker.types';

// State shape for the output material list feature
interface OutputMaterialListState {
  loading: boolean;
  outputMaterialListData?: OutputMaterialListResponse; // Replace with actual data type
  error?: string | null;
}

// Initial state for the output material list slice
const initialState: OutputMaterialListState = {
  loading: false,
  outputMaterialListData: undefined,
  error: null,
};

// Slice for the output material list feature with reducers and extraReducers for async actions
const outputMaterialListSlice = createSlice({
  name: 'outputMaterialList',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      // Handle getOutputMaterialList pending state
      .addCase(getOutputMaterialList.pending, state => {
        state.loading = true;
        state.error = null;
      })

      // Handle getOutputMaterialList fulfilled state
      .addCase(
        getOutputMaterialList.fulfilled,
        (state, action: PayloadAction<OutputMaterialListResponse>) => {
          state.outputMaterialListData = action.payload;
          state.loading = false;
        }
      )

      // Handle getOutputMaterialList rejected state
      .addCase(getOutputMaterialList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

// Export reducer for store
export default outputMaterialListSlice.reducer;
